import React from 'react';

const Question = ({
  question,
  questionId,
  fieldType,
  questionType,
  options = [],
  ui = {},
  studentAnswer,
  onAnswerChange,
}) => {
  const normalizedType =
    String(questionType || fieldType || 'text')
      .toLowerCase()
      .trim() || 'text';

  const renderChoiceOptions = (isMulti = false) =>
    options.map((option, index) => {
      const value = String(option);
      const current = Array.isArray(studentAnswer) ? studentAnswer : [];
      const checked = isMulti ? current.includes(value) : studentAnswer === value;
      return (
        <div key={index}>
          <label>
            <input
              type={isMulti ? 'checkbox' : 'radio'}
              name={isMulti ? `${questionId}_${index}` : questionId}
              value={value}
              checked={checked}
              onChange={(e) => {
                if (!isMulti) {
                  onAnswerChange(questionId, e.target.value);
                  return;
                }
                const next = e.target.checked
                  ? [...current, value]
                  : current.filter((item) => item !== value);
                onAnswerChange(questionId, next);
              }}
            />
            {value}
          </label>
        </div>
      );
    });

  return (
    <div className="question">
      <h3>{question}</h3>

      {normalizedType === 'textarea' || normalizedType === 'long_text' ? (
        <textarea
          value={studentAnswer || ''}
          onChange={(e) => onAnswerChange(questionId, e.target.value)}
          rows={ui.rows || 4}
          placeholder={ui.placeholder || ''}
        />
      ) : normalizedType === 'number' || normalizedType === 'numeric' ? (
        <input
          type="number"
          value={studentAnswer || ''}
          onChange={(e) => onAnswerChange(questionId, e.target.value)}
          min={ui.min}
          max={ui.max}
          placeholder={ui.placeholder || ''}
        />
      ) : normalizedType === 'radio' ||
        normalizedType === 'single_choice' ||
        normalizedType === 'mcq' ? (
        renderChoiceOptions(false)
      ) : normalizedType === 'checkbox' || normalizedType === 'multi_select' ? (
        renderChoiceOptions(true)
      ) : normalizedType === 'boolean' || normalizedType === 'true_false' ? (
        <div>
          <label>
            <input
              type="radio"
              name={`${questionId}_bool`}
              value="true"
              checked={String(studentAnswer) === 'true'}
              onChange={(e) => onAnswerChange(questionId, e.target.value)}
            />
            True
          </label>
          <label style={{ marginLeft: '12px' }}>
            <input
              type="radio"
              name={`${questionId}_bool`}
              value="false"
              checked={String(studentAnswer) === 'false'}
              onChange={(e) => onAnswerChange(questionId, e.target.value)}
            />
            False
          </label>
        </div>
      ) : normalizedType === 'code' ? (
        <textarea
          value={studentAnswer || ''}
          onChange={(e) => onAnswerChange(questionId, e.target.value)}
          rows={ui.rows || 8}
          placeholder={ui.placeholder || 'Write your code here...'}
          style={{ fontFamily: 'monospace' }}
        />
      ) : normalizedType === 'text' || normalizedType === 'short_text' ? (
        <input
          type="text"
          value={studentAnswer || ''}
          onChange={(e) => onAnswerChange(questionId, e.target.value)}
          placeholder={ui.placeholder || ''}
        />
      ) : (
        <input
          type="text" // Default to text input for unknown types
          value={studentAnswer || ''}
          onChange={(e) => onAnswerChange(questionId, e.target.value)}
          placeholder={ui.placeholder || ''}
        />
      )}
    </div>
  );
};

export default Question;
